<template>
  <div>
    <a-table v-if="relationItems.length>0" :columns="columns" size="middle" :data-source="relationItems" :loading="loading" row-key="id">
      <span slot="title" slot-scope="text, record">
        <a class="custom-link" target="_blank" @click="toDetail(record.id, record.type)"> {{ record && record.title ? record.title : '' }}</a>
      </span>
    </a-table>
    <div slot="footer" />
  </div>
</template>

<script>
import { problemUrgencys, problemStatus, ticketStatus, problemChannels, ticketDomain, ticketLevel, ticektTag, qiyuTicketStatus } from '@/utils/dictionary';
import { taskStatus } from '@/utils/dictionary';
import { queryIssuesByIds } from '@/api/project/issue';
import { queryReqByIds } from '@/api/project/story';
export default {
  components: { },
  props: {
    relations: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      bugList: [],
      reqList: [],
      loading: false,
      relationItems: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width: 50,
          scopedSlots: { customRender: 'customKey' }
        },
        {
          title: '标题',
          width: 100,
          dataIndex: 'title',
          key: 'title',
          scopedSlots: { customRender: 'title' }
        },
        {
          title: '类型',
          width: 50,
          dataIndex: 'type',
          key: 'type'
        },
        {
          title: '创建时间',
          width: 50,
          dataIndex: 'createdTime',
          key: 'createdTime'
        }
      ]
    };
  },
  computed: {
    link() {
      return record => {
        return record && record.project && record.taskId ? this.$router.resolve({ name: 'page:project:task:detail', query: { taskId: record.taskId }, params: { project_id: record.project }}).href : '';
      };
    }
  },
  mounted() {
    this.buildMoreInfo();
    setTimeout(() => {
      this.queryBugs();
    }, 10);
    setTimeout(() => {
      this.queryReqs();
    }, 10);
  },
  methods: {
    buildMoreInfo() {
      this.relations.forEach(item => {
        if (item.sourceType === 'bug') {
          this.bugList.push(item.sourceId);
        } else if (item.sourceType === 'requirement') {
          this.reqList.push(item.sourceId);
        }
      });
    },
    queryBugs() {
      this.loading = true;
      queryIssuesByIds({ issueIds: this.bugList })
        .then(res => {
          this.relationItems = this.relationItems.concat(res.data.items);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    queryReqs() {
      if (this.reqList.length > 0) {
        this.loading = true;
        queryReqByIds({ requirementIds: this.reqList })
          .then(res => {
            this.relationItems = this.relationItems.concat(res.data.items);
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    toDetail(ticketId) {
      this.ticketId = ticketId;
      this.editVisible = true;
    },
    open() {
      this.modalVisible = true;
    }
  }
};
</script>

  <style scoped>
      .purple {
        background-color: rgba(128, 50, 150, 0.5);
        color: white;
        border-radius: 6px;
      }

      .orange {
        background-color: orange;
        color: white;
        border-radius: 6px;
      }

      .purple-orange {
        background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
        color: white;
        border-radius: 6px;
      }
  </style>

